class CartDeliveryFeeNotificationController {
    constructor($sce) {
        this.$sce = $sce;
    }
}

CartDeliveryFeeNotificationController.$inject = ['$sce'];

const cartDeliveryFeeNotificationComponentDefinition = {
    controller: CartDeliveryFeeNotificationController,
    bindings: {
        type: '@', // Type of notification (string. error/info/warning/success)
        title: '@?', // Optional title for the notification. (string)
        message: '@?', // Message to the user regarding the notification (string - trusted HTML).
    },
    template: require('./cart-delivery-fee-notification.component.html').trim(),
};

module.exports = {
    CartDeliveryFeeNotificationController,
    cartDeliveryFeeNotificationComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/cart/cart-delivery-fee-notification.component.js